import { useSelector } from 'react-redux';

import { useIsCompanyOnSfsUk } from 'modules/company/hooks';
import { useIsSchedulingUkTransfersFeatureEnabled } from 'modules/invoices/transfer/hooks';

import { getMaxSchedulingDate } from '../payment/models';
import { getSelectedPaymentMethod } from '../redux/selectors';

export const useGetPaymentsMaxSchedulingDate = (): Date => {
  const isCompanyOnSfsUk = useIsCompanyOnSfsUk();
  const isSchedulingUkTransfersFeatureEnabled =
    useIsSchedulingUkTransfersFeatureEnabled();
  const selectedPaymentMethod = useSelector(getSelectedPaymentMethod);

  return getMaxSchedulingDate({
    paymentMethod: selectedPaymentMethod,
    isUkCompany: isCompanyOnSfsUk,
    isSchedulingUkTransfersFeatureEnabled,
    today: new Date(),
  });
};
